import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import AddWasteType from "./add-waste-type";
import apiRequest from "../common/api-request";
import Box from "@material-ui/core/Box";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 3),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const WasteTypes = (props) => {
  const { handleLogOut } = props;
  const classes = useStyles();
  const initialState = {
    allWasteTypes: [],
    action: "Close",
    wasteType: {},
    addAnother: false,
    displaySnackBar: false,
    snackBarMessage: "",
    snackBarautoHideDuration: 2000, //milliseconds
    snackBarVerticalPosition: "top",
    snackBarHorizontalPosition: "right",
    snackBarSeverity: "info",
    loading: false,
  };

  const [state, setState] = useState(initialState);

  const {
    allWasteTypes,
    action,
    wasteType,
    addAnother,
    displaySnackBar,
    snackBarMessage,
    snackBarautoHideDuration,
    snackBarVerticalPosition,
    snackBarHorizontalPosition,
    snackBarSeverity,
    loading,
  } = state;

  const handleLoader = (action) => {
    setState((prevState) => ({
      ...prevState,
      loading: action,
    }));
  };
  const showNotification = (msg, severity) => {
    if (severity.toLowerCase() === "error" && msg.search("401") !== -1) {
      handleLogOut({ msg: "Unauthorized", severity: "error" });
      return;
    }

    if (severity.toLowerCase() === "error" && msg.search("403") !== -1) {
      handleLogOut({ msg: "Token expired", severity: "error" });
      return;
    }

    setState((prevState) => ({
      ...prevState,
      displaySnackBar: true,
      snackBarMessage: msg,
      snackBarSeverity: severity,
    }));
  };

  const handleCloseSnackBar = () => {
    setState((prevState) => ({
      ...prevState,
      displaySnackBar: false,
      isLoading: false,
    }));
  };

  const handleApiData = (params) => {
    const { data, dataName, severity } = params;
    let snackBarMessage = "Success.";
    if (severity === "error") {
      snackBarMessage = data;
    }

    if (severity !== "error" && Array.isArray(data || data?.results)) {
      setState((prevState) => ({
        ...prevState,
        [dataName]: data || data?.results,
        action: addAnother ? action : "Close",
        wasteType: {},
      }));
    }

    if (
      severity !== "error" &&
      (dataName === `addedPartner` || dataName === `updatedPartner`)
    ) {
      (async () => {
        await makeApiRequest({
          uri: `/waste/type/all`,
          dataName: `allWasteTypes`,
          method: `get`,
          data: {},
        });
      })();
    }
    showNotification(snackBarMessage, severity);
  };

  const makeApiRequest = async (params) => {
    const { uri, dataName, method, data } = params;
    const requestParams = {
      handleLoader,
      url: `${process.env.REACT_APP_API_URL}${uri}`,
      data,
      callBack: handleApiData,
      method,
      dataName,
    };
    await apiRequest(requestParams);
  };

  const handleButtonClick = (action) => {
    setState((prevState) => ({
      ...prevState,
      action: addAnother && action === "Add" ? "Add" : action,
      wasteType: action === `Close` ? {} : prevState.wasteType,
    }));
  };

  const handleAddAnother = (wasteType) => {
    setState((prevState) => ({
      ...prevState,
      addAnother: !prevState.addAnother,
      wasteType,
    }));
  };

  const handleChange = async (wasteType) => {
    const { action } = state;
    if (action === `Add`)
      await makeApiRequest({
        uri: `/waste/type`,
        dataName: `addedPartner`,
        method: `post`,
        data: wasteType,
      });

    if (action === `Update`)
      await makeApiRequest({
        uri: `/waste/type/${wasteType.id}`,
        dataName: `updatedPartner`,
        method: `put`,
        data: wasteType,
      });
  };

  useEffect(() => {
    makeApiRequest({
      uri: `/waste/type/all`,
      dataName: `allWasteTypes`,
      method: `get`,
      data: {},
    });
  }, []);

  const columns = [
    {
      label: "Waste Type",
      name: "name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Date Created",
      name: "created",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const date = value.slice(0,-5);
          return `${date}`;
        },
      },
    },
  ];

  const options = {
    jumpToPage: true,
    onRowClick: (_rowData, rowMeta) => {
      if (rowMeta?.dataIndex >= 0) {
        const wasteType = { ...allWasteTypes[rowMeta?.dataIndex] };
        setState((prevState) => ({
          ...prevState,
          wasteType,
          action: "Update",
        }));
      }
    },
    onRowsDelete: (rowsDeleted) => {
      if (!window.confirm(`Are you sure you wish to delete this item?`))
        return false;
      if (Array.isArray(rowsDeleted?.data) && rowsDeleted?.data?.length > 0) {
        rowsDeleted.data.forEach((dataItem, index) => {
          const wasteType = allWasteTypes[dataItem.dataIndex];
          if (wasteType?.id) {
            (async () => {
              await makeApiRequest({
                uri: `/waste/type/${wasteType?.id}`,
                dataName: `deletedCollectedWaste`,
                method: `delete`,
                data: {},
              });
              if (index === rowsDeleted.data.length - 1)
                await makeApiRequest({
                  uri: `/waste/type/all`,
                  dataName: `allWasteTypes`,
                  method: `get`,
                  data: {},
                });
            })();
          }
        });
      }
    },
  };

  return (
    <>
      {" "}
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <Snackbar
        anchorOrigin={{
          vertical: snackBarVerticalPosition,
          horizontal: snackBarHorizontalPosition,
        }}
        open={displaySnackBar}
        onClose={handleCloseSnackBar}
        autoHideDuration={snackBarautoHideDuration}
        // message={snackBarMessage}
      >
        <Alert onClose={handleCloseSnackBar} severity={snackBarSeverity}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
      {(action === "Add" || action === "Update") && (
        <AddWasteType
          handleButtonClick={handleButtonClick}
          action={action}
          wasteType={wasteType}
          handleChange={handleChange}
          handleAddAnother={handleAddAnother}
          addAnother={addAnother}
        />
      )}
      <MUIDataTable
        title={
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleButtonClick(`Add`);
            }}
            startIcon={<AddCircleIcon />}
          >
            New Waste Type
          </Button>
        }
        data={allWasteTypes}
        columns={columns}
        options={options}
      />
    </>
  );
};
export default WasteTypes;
